var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlarm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9976 18C14.9976 19.6583 13.655 21 11.9988 21C10.3426 21 9 19.6559 9 18H15H14.9976Z",
    fill: "#1A2448"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.38994 17C4.89398 17 4.4368 16.7572 4.18189 16.3586C3.86879 15.8624 3.96854 15.2262 4.41463 14.8382L5.67533 13.7455V9.3322C5.6781 5.9589 8.63451 3 12.001 3C15.3675 3 18.3239 5.9589 18.3239 9.3322V13.7455L19.5846 14.8382C20.0335 15.2262 20.1304 15.865 19.8173 16.3586C19.5652 16.7545 19.1052 17 18.6093 17H5.38994Z",
    fill: "#1A2448"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarm);
export default __webpack_public_path__ + "static/media/alarm.76617095a259a4dbeec96307c2745b3f.svg";
export { ForwardRef as ReactComponent };